var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20617 11.6875C7.3575 11.5352 7.44244 11.3293 7.44244 11.1147C7.44244 10.9 7.3575 10.6941 7.20617 10.5418L3.46867 6.81247H22.603C22.8185 6.81247 23.0252 6.72687 23.1776 6.5745C23.3299 6.42212 23.4155 6.21546 23.4155 5.99997C23.4155 5.78448 23.3299 5.57782 23.1776 5.42545C23.0252 5.27307 22.8185 5.18747 22.603 5.18747H3.49305L7.20617 1.47435C7.36025 1.32135 7.44723 1.11341 7.44799 0.896282C7.44876 0.67915 7.36323 0.470609 7.21023 0.316534C7.05724 0.16246 6.8493 0.0754739 6.63217 0.0747121C6.41504 0.0739502 6.2065 0.159475 6.05242 0.312472L0.884921 5.4881C0.748478 5.62514 0.671875 5.81065 0.671875 6.00403C0.671875 6.19742 0.748478 6.38293 0.884921 6.51997L6.05242 11.6875C6.12795 11.7636 6.21782 11.8241 6.31683 11.8653C6.41584 11.9066 6.52204 11.9278 6.6293 11.9278C6.73656 11.9278 6.84275 11.9066 6.94176 11.8653C7.04078 11.8241 7.13064 11.7636 7.20617 11.6875Z",
    fill: "#F5BA41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.bc785cf85baa5d73d52d82f18dde7459.svg";
export { ForwardRef as ReactComponent };